interface Props {
  [key: string]: any
}

function BellAltIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 20 20" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M8.55396 17.4944C8.70019 17.7476 8.91052 17.9579 9.1638 18.1042C9.41707 18.2504 9.70437 18.3274 9.99682 18.3274C10.2893 18.3274 10.5766 18.2504 10.8299 18.1042C11.0831 17.9579 11.2935 17.7476 11.4397 17.4944"
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.66613"
      />
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M2.71741 12.7676C2.60858 12.8868 2.53676 13.0352 2.51069 13.1945C2.48462 13.3539 2.50541 13.5174 2.57055 13.6651C2.63568 13.8129 2.74235 13.9385 2.87757 14.0267C3.0128 14.115 3.17075 14.162 3.33221 14.1621H16.6613C16.8227 14.1622 16.9807 14.1153 17.116 14.0272C17.2513 13.9392 17.3581 13.8137 17.4234 13.666C17.4887 13.5184 17.5097 13.3549 17.4839 13.1956C17.458 13.0362 17.3864 12.8878 17.2777 12.7684C16.1697 11.6263 14.9951 10.4125 14.9951 6.66453C14.9951 5.33887 14.4685 4.06751 13.5311 3.13013C12.5938 2.19275 11.3224 1.66614 9.99673 1.66614C8.67108 1.66614 7.39972 2.19275 6.46234 3.13013C5.52496 4.06751 4.99834 5.33887 4.99834 6.66453C4.99834 10.4125 3.82289 11.6263 2.71741 12.7676Z"
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.66613"
      />
    </svg>
  )
}

export default BellAltIcon
